import React, { useEffect, useRef, useState } from 'react'
import Footer from '../../components/footer/footer';
import { NavLink } from 'react-router-dom';
import { MoveRight, MoveLeft } from 'lucide-react';

const OnlyTv = () => {
    const [TV, setTV] = useState([]);
    const [pagination, setPagination] = useState(4)
    const [page, setPage] = useState(1)

    useEffect(() => {
        fetch(`https://api.themoviedb.org/3/tv/popular?api_key=091d4817f9045622142ffd67a08b2d15&page=${page}`)
            .then(res => res.json())
            .then(res => setTV(res.results))
    }, [page, TV])

    const useRunOnce = ({ fn, sessionKey }) => {
        const triggered = useRef(false);

        useEffect(() => {
            const hasBeenTriggered = sessionKey
                ? sessionStorage.getItem(sessionKey)
                : triggered.current;

            if (!hasBeenTriggered) {
                fn();
                triggered.current = true;

                if (sessionKey) {
                    sessionStorage.setItem(sessionKey, "true");
                }
            }
        }, [fn, sessionKey]);

        return null;
    };

    useRunOnce({
        fn: () => {
            window.scrollTo(0, 0)
        }
    });

    return (
        <div className='relative top-6 lg:top-32 px-2 md:px-7'>
            <h1 className='text-4xl text-white font-bold'>Populare Tv Shows</h1>
            <div className='flex justify-center py-6'>
                <nav className='flex flex-col items-center'>
                    <div class="flex items-center gap-x-1" >
                        <button className={`${page == 1 ? 'hidden' : 'block'} min-h-[38px] min-w-[38px] flex justify-center items-center border border-gray-200 text-gray-800 py-2 px-2 text-sm rounded-lg focus:outline-none focus:bg-[#7300FF] disabled:opacity-50 disabled:pointer-events-none dark:border-neutral-700 dark:text-white dark:hover:bg-[#7300ff3f] dark:focus:bg-[#7300ff3f]`}><MoveLeft strokeWidth={3} onClick={() => setPage(page === 1 ? 1 : page - 1)} /></button>
                        <button onClick={() => setPagination(pagination > 4 ? pagination - 4 : 4)} type="button" class="min-h-[38px] min-w-[38px] py-2 px-2.5 inline-flex justify-center items-center gap-x-2 text-sm rounded-lg border border-transparent text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:border-transparent dark:text-white dark:hover:bg-white/10 dark:focus:bg-white/10" >
                            <svg class="shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="m15 18-6-6 6-6"></path>
                            </svg>
                            <span class="sr-only">Previous</span>
                        </button>
                        <div class="flex items-center gap-x-1">
                            {
                                Array.from(Array(1, 2, 3, 4).reverse(), (v, i) =>
                                    <button type="button" onClick={() => { setTV([]); setPage(pagination - v + 1) }} class="min-h-[38px] min-w-[38px] flex justify-center items-center border border-gray-200 text-gray-800 py-2 px-3 text-sm rounded-lg focus:outline-none focus:bg-[#7300FF] disabled:opacity-50 disabled:pointer-events-none dark:border-neutral-700 dark:text-white dark:hover:bg-[#7300ff3f] dark:focus:bg-[#7300ff3f]" >
                                        {pagination - v + 1}
                                    </button>
                                )
                            }
                        </div>
                        <button onClick={() => setPagination(pagination + 4)} type="button" class="min-h-[38px] min-w-[38px] py-2 px-2.5 inline-flex justify-center items-center gap-x-2 text-sm rounded-lg border border-transparent text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:border-transparent dark:text-white dark:hover:bg-white/10 dark:focus:bg-white/10">
                            <span class="sr-only">Next</span>
                            <svg class="shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="m9 18 6-6-6-6"></path>
                            </svg>
                        </button>
                        <button className=' min-h-[38px] min-w-[38px] flex justify-center items-center border border-gray-200 text-gray-800 py-2 px-2 text-sm rounded-lg focus:outline-none focus:bg-[#7300FF] disabled:opacity-50 disabled:pointer-events-none dark:border-neutral-700 dark:text-white dark:hover:bg-[#7300ff3f] dark:focus:bg-[#7300ff3f]'><MoveRight strokeWidth={3} onClick={() => setPage(page + 1)} /></button>
                    </div>
                        <span className='text-white py-1 my-1 rounded-lg bg-[#7300ff5e] px-3'>Page : {page}</span>
                </nav>
            </div>
            <div className='flex flex-wrap justify-center gap-5 mt-5'>
                {
                    TV?.length > 0 ? TV?.map((tv, i) =>
                        <NavLink to={`/${tv?.id}?type=tv`} className='flex-shrink-0 rounded-xl'>
                            <img src={`https://image.tmdb.org/t/p/w300/${tv.poster_path}`} alt="" className='h-[264px] w-44 rounded-xl ' />
                            <h1 className='text-white w-44 text-center'>{tv?.name}</h1>
                        </NavLink>
                    )
                        : Array.from(Array(20), () =>
                            <div className='flex flex-wrap justify-center gap-5 mt-5'>
                                <div className='flex-shrink-0  bg-stone-600 rounded-xl animate-pulse'>
                                    <div className='w-44 h-[264px] '></div>
                                </div>
                            </div>
                        )
                }
            </div>
            <div className='flex justify-center py-6'>
                <nav class="flex items-center gap-x-1" aria-label="Pagination">
                    <button className={`${page == 1 ? 'hidden' : 'block'} min-h-[38px] min-w-[38px] flex justify-center items-center border border-gray-200 text-gray-800 py-2 px-2 text-sm rounded-lg focus:outline-none focus:bg-[#7300FF] disabled:opacity-50 disabled:pointer-events-none dark:border-neutral-700 dark:text-white dark:hover:bg-[#7300ff3f] dark:focus:bg-[#7300ff3f]`}><MoveLeft strokeWidth={3} onClick={() => setPage(page === 1 ? 1 : page - 1)} /></button>
                    <button onClick={() => setPagination(pagination > 4 ? pagination - 4 : 4)} type="button" class="min-h-[38px] min-w-[38px] py-2 px-2.5 inline-flex justify-center items-center gap-x-2 text-sm rounded-lg border border-transparent text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:border-transparent dark:text-white dark:hover:bg-white/10 dark:focus:bg-white/10" >
                        <svg class="shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="m15 18-6-6 6-6"></path>
                        </svg>
                        <span class="sr-only">Previous</span>
                    </button>
                    <div class="flex items-center gap-x-1">
                        {
                            Array.from(Array(1, 2, 3, 4).reverse(), (v, i) =>
                                <button type="button" onClick={() => { setTV([]); setPage(pagination - v + 1) }} class="min-h-[38px] min-w-[38px] flex justify-center items-center border border-gray-200 text-gray-800 py-2 px-3 text-sm rounded-lg focus:outline-none focus:bg-[#7300FF] disabled:opacity-50 disabled:pointer-events-none dark:border-neutral-700 dark:text-white dark:hover:bg-[#7300ff3f] dark:focus:bg-[#7300ff3f]" >
                                    {pagination - v + 1}
                                </button>
                            )
                        }
                    </div>
                    <button onClick={() => setPagination(pagination + 4)} type="button" class="min-h-[38px] min-w-[38px] py-2 px-2.5 inline-flex justify-center items-center gap-x-2 text-sm rounded-lg border border-transparent text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:border-transparent dark:text-white dark:hover:bg-white/10 dark:focus:bg-white/10">
                        <span class="sr-only">Next</span>
                        <svg class="shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="m9 18 6-6-6-6"></path>
                        </svg>
                    </button>
                    <button className=' min-h-[38px] min-w-[38px] flex justify-center items-center border border-gray-200 text-gray-800 py-2 px-2 text-sm rounded-lg focus:outline-none focus:bg-[#7300FF] disabled:opacity-50 disabled:pointer-events-none dark:border-neutral-700 dark:text-white dark:hover:bg-[#7300ff3f] dark:focus:bg-[#7300ff3f]'><MoveRight strokeWidth={3} onClick={() => setPage(page + 1)} /></button>
                </nav>
            </div>
            <div>
                <Footer></Footer>
            </div>
        </div>
    )
}

export default OnlyTv
